export const Arr_SENDInfo = [
  //-------------------------------------------------------------------------
  //SEND

  // Start ADHD
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student experience ADHD/ ADD",
    name: "Arr_SENDInfo_ADHD",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p>
        Attention Deficit Hyperactivity Disorder/ Attention Deficit Disorder
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Which do they experience",
    name: "Arr_SENDInfo_ADHD_which",
    selectValues: ["ADHD", "ADD", "ADHD and ADD"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "How much does their ADHD/ ADD impact their day-to-day",
    name: "Arr_SENDInfo_ADHD_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "Does the student have an education care plan created with their school",
    name: "Arr_SENDInfo_ADHD_educational_plan",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD",
    AboveText: (
      <p>
        If the student has an education care plan created with their school,
        please feel free to email it to us at info@investin.org
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Additional support",
    name: "Arr_SENDInfo_ADHD_additional_support",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD",
    AboveText: (
      <p>
        Does the student receive additional support at school in their
        day-to-day? This does not include examination settings or test
        preparation as there are no exams during their programme
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "Arr_SENDInfo_ADHD_support",
    selectValues: [
      {
        name: "Arr_SENDInfo_ADHD_support_day_timings",
        label:
          "Provide the student with in-depth information about each element of the programme day-by-day with timings (note these might be approximate and could be subject to change)",
      },
      {
        name: "Arr_SENDInfo_ADHD_support_breaks",
        label:
          "Give the student the opportunity for short breaks outside of the room/ environment",
      },
      {
        name: "Arr_SENDInfo_ADHD_support_quiet_space",
        label: "Quiet space to decompress during a busy environment",
      },
      {
        name: "Arr_SENDInfo_ADHD_support_move_around",
        label: "Give the student the opportunity to move around the space",
      },
      {
        name: "Arr_SENDInfo_ADHD_support_buddy_system",
        label:
          "Try to pair the student with another student as a buddy (note this may not always be possible)",
      },
      {
        name: "Arr_SENDInfo_ADHD_support_opt_out_presentations_alone",
        label:
          "Opt out of giving presentations alone (and co-deliver with another student)",
      },
      {
        name: "Arr_SENDInfo_ADHD_support_opt_out_presentations_completely",
        label:
          "Opt out of giving presentations completely (no public speaking)",
      },
      {
        name: "Arr_SENDInfo_ADHD_support_coloured_overlay",
        label:
          "A coloured overlay to support with reading information printed out (please tell us which colour in the ‘other’ section below)",
      },
      {
        name: "Arr_SENDInfo_ADHD_plan_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_additional_support",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        Please review some suggestions for support that we can offer below and
        select the options you think would be helpful for the student
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details on the other support",
    name: "Arr_SENDInfo_ADHD_plan_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_plan_other",
  },

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "Arr_SENDInfo_ADHD_signs",
    selectValues: [
      {
        name: "Arr_SENDInfo_ADHD_signs_fidgety",
        label: "Fidgety or find it challenging to sit still in their place",
      },
      {
        name: "Arr_SENDInfo_ADHD_signs_misbehaviour",
        label: "Low-level misbehaviour",
      },
      {
        name: "Arr_SENDInfo_ADHD_signs_hyperfixation",
        label: "Hyperfixation on an activity/ task/ thought process",
      },
      {
        name: "Arr_SENDInfo_ADHD_signs_distracted",
        label:
          "Be distracted by other students or things outside of the learning programme",
      },
      {
        name: "Arr_SENDInfo_ADHD_signs_more_communicative",
        label: "Be more communicative with staff and/ or peers",
      },
      {
        name: "Arr_SENDInfo_ADHD_signs_less_communicative",
        label: "Be more withdrawn and less communicative",
      },
      {
        name: "Arr_SENDInfo_ADHD_signs_phone_use",
        label: "Use their phone excessively",
      },
      {
        name: "Arr_SENDInfo_ADHD_signs_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        If the student is finding it challenging to concentrate or is distracted
        during the programme, it is useful for us to know what this looks like
        for each student so we can care for their well-being. Please tell us how
        we might recognise this for the student, will the student be
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details on the other signs",
    name: "Arr_SENDInfo_ADHD_signs_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_signs_other",
  },
  // ADHD Medication start

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Medication",
    name: "Arr_SENDInfo_ADHD_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD",
    AboveText: (
      <p>Does the student take any medication related to their condition</p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "Arr_SENDInfo_ADHD_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_prescribed_medication",
  },

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "Arr_SENDInfo_ADHD_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_prescribed_medication",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "Arr_SENDInfo_ADHD_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "Arr_SENDInfo_ADHD_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_prescribed_medication",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. tablet)",
    name: "Arr_SENDInfo_ADHD_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_prescribed_medication",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "Arr_SENDInfo_ADHD_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_prescribed_medication",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "Arr_SENDInfo_ADHD_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago):
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "Arr_SENDInfo_ADHD_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "Arr_SENDInfo_ADHD_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_ADHD_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_prescribed_medication_interact_badly",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "Arr_SENDInfo_ADHD_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_ADHD_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_prescribed_medication_anything_else",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Any specific aftercare needs",
    name: "Arr_SENDInfo_ADHD_prescribed_medication_aftercare",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific aftercare needs the student may have? (E.g. are
        there any additional symptoms we should be aware of once the medicine
        has been provided)
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_ADHD_prescribed_medication_aftercare_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_prescribed_medication_aftercare",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "Arr_SENDInfo_ADHD_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_ADHD_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "Arr_SENDInfo_ADHD_prescribed_medication_storage_requirements",
  },
  // ADHD Medication end
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Serious incident",
    name: "Arr_SENDInfo_ADHD_serious_incident",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD",
    AboveText: (
      <p>
        Has the student had a serious incident related to their SEN and required
        urgent or emergency treatment within the last 12 months
      </p>
    ),
  },

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the emergency",
    name: "Arr_SENDInfo_ADHD_serious_incident_trigger",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_serious_incident",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "When was the most recent incident",
    name: "Arr_SENDInfo_ADHD_serious_incident_most_recent",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_serious_incident",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Was the student admitted overnight to the hospital",
    name: "Arr_SENDInfo_ADHD_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_serious_incident",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "How often",
    name: "Arr_SENDInfo_ADHD_serious_incident_how_often",
    selectValues: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_serious_incident",
    AboveText: (
      <p>
        How often has the student experienced an incident related to their SEN
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "Arr_SENDInfo_ADHD_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        student’s SEN, such as any other access needs that the student would
        need for the duration of their programme
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_ADHD_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_ADHD_anything_else",
  },
  // End ADHD

  // Start learning_need
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student have an SEN requirement",
    name: "Arr_SENDInfo_learning_need",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p>
        Does the student have a specific educational or learning need? For
        example, dyslexia, dysgraphia, dyspraxia, dyscalculia. For more
        information,{" "}
        <a
          href="https://www.familylives.org.uk/advice/your-family/special-educational-needs/what-are-special-educational-needs"
          target="_blank"
        >
          <strong>please click this link </strong>
        </a>
      </p>
    ),
  },

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "Arr_SENDInfo_learning_need_which",
    selectValues: [
      {
        name: "Arr_SENDInfo_learning_need_which_dyslexia",
        label: "Dyslexia",
      },
      {
        name: "Arr_SENDInfo_learning_need_which_dysgraphia",
        label: "Dysgraphia",
      },
      {
        name: "Arr_SENDInfo_learning_need_which_dyspraxia",
        label: "Dyspraxia",
      },
      {
        name: "Arr_SENDInfo_learning_need_which_dyscalculia",
        label: "Dyscalculia",
      },
      {
        name: "Arr_SENDInfo_learning_need_which_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need",
    SpecialCondition: "Optional",
    AboveText: <p>Please tell us about their learning need</p>,
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details on the other learning need",
    name: "Arr_SENDInfo_learning_need_which_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_which_other",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "How much does their learning need impact their day-to-day",
    name: "Arr_SENDInfo_learning_need_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "Does the student have an education care plan created with their school",
    name: "Arr_SENDInfo_learning_need_educational_plan",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need",
    AboveText: (
      <p>
        If the student has an education care plan created with their school,
        please feel free to email it to us at info@investin.org
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Additional support",
    name: "Arr_SENDInfo_learning_need_additional_support",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need",
    AboveText: (
      <p>
        Does the student receive additional support at school in their
        day-to-day? This does not include examination settings or test
        preparation as there are no exams during their programme
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "Arr_SENDInfo_learning_need_support",
    selectValues: [
      {
        name: "Arr_SENDInfo_learning_need_support_day_timings",
        label:
          "Provide the student with in-depth information about each element of the programme day-by-day with timings (note these might be approximate and could be subject to change)",
      },
      {
        name: "Arr_SENDInfo_learning_need_support_breaks",
        label:
          "Give the student the opportunity for short breaks outside of the room/ environment",
      },
      {
        name: "Arr_SENDInfo_learning_need_support_quiet_space",
        label: "Quiet space to decompress during a busy environment",
      },
      {
        name: "Arr_SENDInfo_learning_need_support_move_around",
        label: "Give the student the opportunity to move around the space",
      },
      {
        name: "Arr_SENDInfo_learning_need_support_buddy_system",
        label:
          "Try to pair the student with another student as a buddy (note this may not always be possible)",
      },
      {
        name: "Arr_SENDInfo_learning_need_support_opt_out_presentations_alone",
        label:
          "Opt out of giving presentations alone (and co-deliver with another student)",
      },
      {
        name: "Arr_SENDInfo_learning_need_support_opt_out_presentations_completely",
        label:
          "Opt out of giving presentations completely (no public speaking)",
      },
      {
        name: "Arr_SENDInfo_learning_need_support_coloured_overlay",
        label:
          "A coloured overlay to support with reading information printed out (please tell us which colour in the ‘other’ section below)",
      },
      {
        name: "Arr_SENDInfo_learning_need_plan_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_additional_support",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        Please review some suggestions for support that we can offer below and
        select the options you think would be helpful for the student
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details on the other support",
    name: "Arr_SENDInfo_learning_need_plan_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_plan_other",
  },

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "Arr_SENDInfo_learning_need_signs",
    selectValues: [
      {
        name: "Arr_SENDInfo_learning_need_signs_fidgety",
        label: "Fidgety or find it challenging to sit still in their place",
      },
      {
        name: "Arr_SENDInfo_learning_need_signs_misbehaviour",
        label: "Low-level misbehaviour",
      },
      {
        name: "Arr_SENDInfo_learning_need_signs_hyperfixation",
        label: "Hyperfixation on an activity/ task/ thought process",
      },
      {
        name: "Arr_SENDInfo_learning_need_signs_distracted",
        label:
          "Be distracted by other students or things outside of the learning programme",
      },
      {
        name: "Arr_SENDInfo_learning_need_signs_more_communicative",
        label: "Be more communicative with staff and/ or peers",
      },
      {
        name: "Arr_SENDInfo_learning_need_signs_less_communicative",
        label: "Be more withdrawn and less communicative",
      },
      {
        name: "Arr_SENDInfo_learning_need_signs_phone_use",
        label: "Use their phone excessively",
      },
      {
        name: "Arr_SENDInfo_learning_need_signs_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        If the student is finding it challenging to concentrate or is distracted
        during the programme, it is useful for us to know what this looks like
        for each student so we can care for their well-being. Please tell us how
        we might recognise this for the student, will the student be
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details on the other signs",
    name: "Arr_SENDInfo_learning_need_signs_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_signs_other",
  },
  // learning_need Medication start

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Medication",
    name: "Arr_SENDInfo_learning_need_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need",
    AboveText: (
      <p>Does the student take any medication related to their condition</p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "Arr_SENDInfo_learning_need_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_prescribed_medication",
  },

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "Arr_SENDInfo_learning_need_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_prescribed_medication",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "Arr_SENDInfo_learning_need_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "Arr_SENDInfo_learning_need_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_prescribed_medication",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. tablet)",
    name: "Arr_SENDInfo_learning_need_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_prescribed_medication",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "Arr_SENDInfo_learning_need_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_prescribed_medication",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "Arr_SENDInfo_learning_need_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago):
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "Arr_SENDInfo_learning_need_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "Arr_SENDInfo_learning_need_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_learning_need_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "Arr_SENDInfo_learning_need_prescribed_medication_interact_badly",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "Arr_SENDInfo_learning_need_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_learning_need_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "Arr_SENDInfo_learning_need_prescribed_medication_anything_else",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Any specific aftercare needs",
    name: "Arr_SENDInfo_learning_need_prescribed_medication_aftercare",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific aftercare needs the student may have? (E.g. are
        there any additional symptoms we should be aware of once the medicine
        has been provided)
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_learning_need_prescribed_medication_aftercare_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_prescribed_medication_aftercare",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "Arr_SENDInfo_learning_need_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_learning_need_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "Arr_SENDInfo_learning_need_prescribed_medication_storage_requirements",
  },
  // learning_need Medication end
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Serious incident",
    name: "Arr_SENDInfo_learning_need_serious_incident",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need",
    AboveText: (
      <p>
        Has the student had a serious incident related to their SEN and required
        urgent or emergency treatment within the last 12 months
      </p>
    ),
  },

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the emergency",
    name: "Arr_SENDInfo_learning_need_serious_incident_trigger",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_serious_incident",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "When was the most recent incident",
    name: "Arr_SENDInfo_learning_need_serious_incident_most_recent",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_serious_incident",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Was the student admitted overnight to the hospital",
    name: "Arr_SENDInfo_learning_need_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_serious_incident",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "How often",
    name: "Arr_SENDInfo_learning_need_serious_incident_how_often",
    selectValues: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_serious_incident",
    AboveText: (
      <p>
        How often has the student experienced an incident related to their SEN
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "Arr_SENDInfo_learning_need_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        student’s SEN, such as any other access needs that the student would
        need for the duration of their programme
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_learning_need_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_learning_need_anything_else",
  },
  // End learning_need

  // Start autistic
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is the student autistic",
    name: "Arr_SENDInfo_autistic",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p>
        Is the student autistic? For more information{" "}
        <a
          href="https://www.nhs.uk/conditions/autism/what-is-autism/"
          target="_blank"
        >
          <strong>please click this link</strong>
        </a>
      </p>
    ),
  },

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please tell us about their autism",
    name: "Arr_SENDInfo_autistic_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "How much does their autistic impact their day-to-day",
    name: "Arr_SENDInfo_autistic_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Additional support",
    name: "Arr_SENDInfo_autistic_additional_support",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic",
    AboveText: (
      <p>
        Will the student require any additional support during their programme
        related to their autism
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "Arr_SENDInfo_autistic_support",
    selectValues: [
      {
        name: "Arr_SENDInfo_autistic_support_day_timings",
        label:
          "Provide the student with in-depth information about each element of the programme day-by-day with timings (note these might be approximate and could be subject to change)",
      },
      {
        name: "Arr_SENDInfo_autistic_support_breaks",
        label:
          "Give the student the opportunity for short breaks outside of the room/ environment",
      },
      {
        name: "Arr_SENDInfo_autistic_support_quiet_space",
        label: "Quiet space to decompress during a busy environment",
      },
      {
        name: "Arr_SENDInfo_autistic_support_move_around",
        label: "Give the student the opportunity to move around the space",
      },
      {
        name: "Arr_SENDInfo_autistic_support_buddy_system",
        label:
          "Try to pair the student with another student as a buddy (note this may not always be possible)",
      },
      {
        name: "Arr_SENDInfo_autistic_support_opt_out_presentations_alone",
        label:
          "Opt out of giving presentations alone (and co-deliver with another student)",
      },
      {
        name: "Arr_SENDInfo_autistic_support_opt_out_presentations_completely",
        label:
          "Opt out of giving presentations completely (no public speaking)",
      },
      {
        name: "Arr_SENDInfo_autistic_support_coloured_overlay",
        label:
          "A coloured overlay to support with reading information printed out (please tell us which colour in the ‘other’ section below)",
      },
      {
        name: "Arr_SENDInfo_autistic_plan_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_additional_support",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        Please review some suggestions for support that we can offer below and
        select the options you think would be helpful for the student
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details on the other support",
    name: "Arr_SENDInfo_autistic_plan_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_plan_other",
  },

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "Arr_SENDInfo_autistic_signs",
    selectValues: [
      {
        name: "Arr_SENDInfo_autistic_signs_fidgety",
        label: "Fidgety or find it challenging to sit still in their place",
      },
      {
        name: "Arr_SENDInfo_autistic_signs_misbehaviour",
        label: "Low-level misbehaviour",
      },
      {
        name: "Arr_SENDInfo_autistic_signs_hyperfixation",
        label: "Hyperfixation on an activity/ task/ thought process",
      },
      {
        name: "Arr_SENDInfo_autistic_signs_distracted",
        label:
          "Be distracted by other students or things outside of the learning programme",
      },
      {
        name: "Arr_SENDInfo_autistic_signs_more_communicative",
        label: "Be more communicative with staff and/ or peers",
      },
      {
        name: "Arr_SENDInfo_autistic_signs_less_communicative",
        label: "Be more withdrawn and less communicative",
      },
      {
        name: "Arr_SENDInfo_autistic_signs_phone_use",
        label: "Use their phone excessively",
      },
      {
        name: "Arr_SENDInfo_autistic_signs_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        If the student is finding it challenging to concentrate or is distracted
        during the programme, it is useful for us to know what this looks like
        for each student so we can care for their well-being. Please tell us how
        we might recognise this for the student, will the student be
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details on the other signs",
    name: "Arr_SENDInfo_autistic_signs_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_signs_other",
  },
  // autistic Medication start

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Medication",
    name: "Arr_SENDInfo_autistic_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic",
    AboveText: (
      <p>Does the student take any medication related to their condition</p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "Arr_SENDInfo_autistic_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_prescribed_medication",
  },

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "Arr_SENDInfo_autistic_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_prescribed_medication",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "Arr_SENDInfo_autistic_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "Arr_SENDInfo_autistic_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_prescribed_medication",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. tablet)",
    name: "Arr_SENDInfo_autistic_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_prescribed_medication",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "Arr_SENDInfo_autistic_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_prescribed_medication",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "Arr_SENDInfo_autistic_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago):
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "Arr_SENDInfo_autistic_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "Arr_SENDInfo_autistic_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_autistic_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_prescribed_medication_interact_badly",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "Arr_SENDInfo_autistic_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_autistic_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_prescribed_medication_anything_else",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Any specific aftercare needs",
    name: "Arr_SENDInfo_autistic_prescribed_medication_aftercare",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific aftercare needs the student may have? (E.g. are
        there any additional symptoms we should be aware of once the medicine
        has been provided)
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_autistic_prescribed_medication_aftercare_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_prescribed_medication_aftercare",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "Arr_SENDInfo_autistic_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_autistic_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "Arr_SENDInfo_autistic_prescribed_medication_storage_requirements",
  },
  // autistic Medication end
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Serious incident",
    name: "Arr_SENDInfo_autistic_serious_incident",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic",
    AboveText: (
      <p>
        Has the student had a serious incident related to their SEN and required
        urgent or emergency treatment within the last 12 months
      </p>
    ),
  },

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the emergency",
    name: "Arr_SENDInfo_autistic_serious_incident_trigger",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_serious_incident",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "When was the most recent incident",
    name: "Arr_SENDInfo_autistic_serious_incident_most_recent",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_serious_incident",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Was the student admitted overnight to the hospital",
    name: "Arr_SENDInfo_autistic_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_serious_incident",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "How often",
    name: "Arr_SENDInfo_autistic_serious_incident_how_often",
    selectValues: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_serious_incident",
    AboveText: (
      <p>
        How often has the student experienced an incident related to their SEN
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "Arr_SENDInfo_autistic_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        student’s SEN, such as any other access needs that the student would
        need for the duration of their programme
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_autistic_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_autistic_anything_else",
  },
  // End autistic

  // Start speech_language
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Speech and language needs",
    name: "Arr_SENDInfo_speech_language",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p>
        Does the student have any speech and language needs? (This question is
        not about the student’s level of English, this is about SEND
        requirements related to speech and language). For more information{" "}
        <a
          href="https://www.devon.gov.uk/education-and-families/send-local-offer/about-send-and-the-local-offer/what-is-send/communication-and-interaction/guide/"
          target="_blank"
        >
          <strong>please click this link</strong>
        </a>
      </p>
    ),
  },

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please tell us about their needs",
    name: "Arr_SENDInfo_speech_language_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "How much does their speech and language impact their day-to-day",
    name: "Arr_SENDInfo_speech_language_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Additional support",
    name: "Arr_SENDInfo_speech_language_additional_support",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language",
    AboveText: (
      <p>
        Will the student require any additional support during their programme
        related to their speech and language? Please be aware that InvestIN
        staff members are not experts in speech and language needs
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please tell us how we can best support them",
    name: "Arr_SENDInfo_speech_language_additional_support_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language_additional_support",
  },

  // speech_language Medication start

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Medication",
    name: "Arr_SENDInfo_speech_language_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language",
    AboveText: (
      <p>Does the student take any medication related to their condition</p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "Arr_SENDInfo_speech_language_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language_prescribed_medication",
  },

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "Arr_SENDInfo_speech_language_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language_prescribed_medication",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "Arr_SENDInfo_speech_language_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "Arr_SENDInfo_speech_language_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language_prescribed_medication",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. tablet)",
    name: "Arr_SENDInfo_speech_language_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language_prescribed_medication",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "Arr_SENDInfo_speech_language_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language_prescribed_medication",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "Arr_SENDInfo_speech_language_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago):
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "Arr_SENDInfo_speech_language_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "Arr_SENDInfo_speech_language_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_speech_language_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "Arr_SENDInfo_speech_language_prescribed_medication_interact_badly",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "Arr_SENDInfo_speech_language_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_speech_language_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "Arr_SENDInfo_speech_language_prescribed_medication_anything_else",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Any specific aftercare needs",
    name: "Arr_SENDInfo_speech_language_prescribed_medication_aftercare",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific aftercare needs the student may have? (E.g. are
        there any additional symptoms we should be aware of once the medicine
        has been provided)
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_speech_language_prescribed_medication_aftercare_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "Arr_SENDInfo_speech_language_prescribed_medication_aftercare",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "Arr_SENDInfo_speech_language_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_speech_language_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "Arr_SENDInfo_speech_language_prescribed_medication_storage_requirements",
  },
  // speech_language Medication end
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Serious incident",
    name: "Arr_SENDInfo_speech_language_serious_incident",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language",
    AboveText: (
      <p>
        Has the student had a serious incident related to their speech and
        language and required urgent or emergency treatment within the last 12
        months
      </p>
    ),
  },

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the emergency",
    name: "Arr_SENDInfo_speech_language_serious_incident_trigger",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language_serious_incident",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "When was the most recent incident",
    name: "Arr_SENDInfo_speech_language_serious_incident_most_recent",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language_serious_incident",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Was the student admitted overnight to the hospital",
    name: "Arr_SENDInfo_speech_language_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language_serious_incident",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "How often",
    name: "Arr_SENDInfo_speech_language_serious_incident_how_often",
    selectValues: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language_serious_incident",
    AboveText: (
      <p>
        How often has the student experienced an incident related to their SEN
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "Arr_SENDInfo_speech_language_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language",
    AboveText: (
      <p>
        Is there anything else that would help us know about the student’s
        speech and language needs
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_speech_language_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_speech_language_anything_else",
  },
  // End speech_language

  // Start other
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Other needs",
    name: "Arr_SENDInfo_other",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please tell us about their needs",
    name: "Arr_SENDInfo_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "How much does this impact their day-to-day",
    name: "Arr_SENDInfo_other_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Additional support",
    name: "Arr_SENDInfo_other_additional_support",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other",
    AboveText: (
      <p>
        Will the student require any additional support during their programme
        related to this need?
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please tell us how we can best support them",
    name: "Arr_SENDInfo_other_additional_support_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_additional_support",
  },

  // other Medication start

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Medication",
    name: "Arr_SENDInfo_other_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other",
    AboveText: (
      <p>Does the student take any medication related to their condition</p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "Arr_SENDInfo_other_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_prescribed_medication",
  },

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "Arr_SENDInfo_other_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_prescribed_medication",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "Arr_SENDInfo_other_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "Arr_SENDInfo_other_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_prescribed_medication",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. tablet)",
    name: "Arr_SENDInfo_other_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_prescribed_medication",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "Arr_SENDInfo_other_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_prescribed_medication",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "Arr_SENDInfo_other_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago):
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "Arr_SENDInfo_other_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please see{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "Arr_SENDInfo_other_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_other_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_prescribed_medication_interact_badly",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "Arr_SENDInfo_other_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_other_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_prescribed_medication_anything_else",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Any specific aftercare needs",
    name: "Arr_SENDInfo_other_prescribed_medication_aftercare",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific aftercare needs the student may have? (E.g. are
        there any additional symptoms we should be aware of once the medicine
        has been provided)
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_other_prescribed_medication_aftercare_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_prescribed_medication_aftercare",
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Storage requirements",
    name: "Arr_SENDInfo_other_prescribed_medication_storage_requirements",
    selectValues: [
      "Yes – it must be kept in a refrigerator",
      "Yes – other (please specify)",
      "No",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_prescribed_medication",
    AboveText: (
      <p>
        Are there any specific storage requirements for this medication during
        programme hours? For example, the medication must be refrigerated
      </p>
    ),
  },
  {
    Page: "Arr_MedicationsInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_other_prescribed_medication_storage_requirements_specify",
    onlyAppearIfValueIs: ["Yes – other (please specify)"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "Arr_SENDInfo_other_prescribed_medication_storage_requirements",
  },
  // other Medication end
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Serious incident",
    name: "Arr_SENDInfo_other_serious_incident",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other",
    AboveText: (
      <p>
        Has the student had a serious incident related to their condition and
        required urgent or emergency treatment within the last 12 months
      </p>
    ),
  },

  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the emergency",
    name: "Arr_SENDInfo_other_serious_incident_trigger",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_serious_incident",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "When was the most recent incident",
    name: "Arr_SENDInfo_other_serious_incident_most_recent",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_serious_incident",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Was the student admitted overnight to the hospital",
    name: "Arr_SENDInfo_other_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_serious_incident",
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "How often",
    name: "Arr_SENDInfo_other_serious_incident_how_often",
    selectValues: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_serious_incident",
    AboveText: (
      <p>
        How often has the student experienced an incident related to their SEN
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "Arr_SENDInfo_other_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other",
    AboveText: (
      <p>
        Is there anything else that would help us know about the student’s needs
      </p>
    ),
  },
  {
    Page: "Arr_Arr_SENDInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "Arr_SENDInfo_other_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arr_SENDInfo_other_anything_else",
  },
  // End other
];
